const initial = {
    caps: null
};

export const UsersCapsReducer = (state = initial, action) => {
  switch (action.type) {
    case "getCaps":
        console.log(action.payload)
        return {
            ...state,
            caps: action.payload
        }
    default:
      return state;
  }
};
